import { css } from '@emotion/react';

export const breaker = css`
  order: 2;
  flex-basis: 100%;
  width: 100%;
  height: 0;
  overflow: hidden;
`;
